let curriculum = {};
let maze = {};

export const setCurriculum = (c) => { curriculum = c; };
export const getCurriculum = () => curriculum;

export const setMaze = (m) => { maze = m; };
export const getMaze = () => maze;
